import { shouldTableSortByRenewTime } from 'owa-mail-list-response-processor';
import { getTimeGroupHeader } from 'owa-mail-group-headers';
import { MailRowDataPropertyGetter } from 'owa-mail-list-store';
/**
 * Get TimeGroupHeader for item
 * @param rowKey item key for which we want to lookup time group range
 * @param tableView tableView
 * @return group header for this row
 */
export default function getGroupHeaderForSortByDateTime(rowKey, tableView) {
    var deliveryOrRenewTimeStamp = null;
    if (shouldTableSortByRenewTime(tableView.tableQuery)) {
        deliveryOrRenewTimeStamp = MailRowDataPropertyGetter.getLastDeliveryOrRenewTimeStamp(rowKey, tableView);
    }
    else {
        deliveryOrRenewTimeStamp = MailRowDataPropertyGetter.getLastDeliveryTimeStamp(rowKey, tableView);
    }
    return getTimeGroupHeader(new Date(deliveryOrRenewTimeStamp).getTime());
}
//# sourceMappingURL=getGroupHeaderForSortByDateTime.js.map